export default __webpack_public_path__ + "static/media/banner-6.51d87d64.jpg";